import { gql } from "@apollo/client";

/**
 * Quick-links persistence for the home-page grid (AdminModuleLinks).
 *
 * A copy of the `saveMyQuickLinks` operation rather than an import from
 * `src/pages/clients/queries.ts` — app chrome must not reach into a module's
 * folder (Module Sync carries module folders verbatim; anything outside them
 * does not travel). The server field is `Client.preferences.quickLinks`, which
 * AuthContext already selects on `myClient`.
 */
export const SAVE_MY_QUICKLINKS = gql`
  mutation SaveMyQuickLinks($order: [String!]!, $hidden: [String!]!) {
    saveMyQuickLinks(order: $order, hidden: $hidden) {
      quickLinks {
        order
        hidden
      }
    }
  }
`;

/** localStorage mirror of the server prefs — read first on mount so the layout appears instantly. */
export const QUICKLINKS_MIRROR_KEY = "onegroup:quicklinks:v1";
